import { FormattedHubEvent, HubEvent } from '../models/hub.model';

export const getUniqueUpcomingEvents = (
  seasonFights: HubEvent[],
): FormattedHubEvent[] => {
  return seasonFights
    .filter((fight) => new Date(fight.date) > new Date())
    .reduce<FormattedHubEvent[]>((uniqueEvents, fight) => {
      if (
        !uniqueEvents.some((event) => event.event_name === fight.event_name)
      ) {
        uniqueEvents.push({
          event_name: fight.event_name,
          formatted_date: new Date(fight.date).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
          }),
        });
      }
      return uniqueEvents;
    }, [])
    .sort(
      (a, b) =>
        new Date(a.formatted_date).getTime() -
        new Date(b.formatted_date).getTime(),
    );
};
